<script setup lang="ts">
import PageLoaderEventList from '~/components/loader/PageLoaderEventList.vue'
import PageLoaderStrapi from '~/components/loader/PageLoaderStrapi.vue'
import PageLoaderEventDetail from '~/components/loader/PageLoaderEventDetail.vue'
import PageLoaderMagazine from '~/components/loader/PageLoaderMagazine.vue'
import PageLoaderMagazineHome from '~/components/loader/PageLoaderMagazineHome.vue'
import PageLoaderHome from '~/components/loader/PageLoaderHome.vue'

const nuxtApp = useNuxtApp()
const router = useRouter()
const loading = ref<boolean>(false)

/*
  Preloader components mapper,
  you can provide your own key using definePageMeta on any page
  
  definePageMeta({
    preloaderType: 'your-key',
  })
*/
const loadersTypeMapper: Record<string, any> = {
  // default and fallback
  default: PageLoaderEventList,
  // for strapi static pages
  strapi: PageLoaderStrapi,
  // for event details
  eventDetail: PageLoaderEventDetail,
  // for magazine article details
  magazine: PageLoaderMagazine,
  // for magazine home page
  magazineHome: PageLoaderMagazineHome,
  // homepage
  home: PageLoaderHome,
}
const loadingType = ref<string>('default')

nuxtApp.hook('page:start', (): void => {
  loading.value = true
  const preloaderType = router?.currentRoute?.value?.meta?.preloaderType
  loadingType.value = preloaderType ? String(preloaderType) : 'default'
})

nuxtApp.hook('page:finish', (): void => {
  loading.value = false
})
</script>

<template>
  <Transition name="fade">
    <div
      v-if="loading"
      class="preloader-wrapper fixed left-0 top-0 h-full flex justify-center w-full bg-white overflow-hidden"
    >
      <div class="pt-[138px] max-w-(--breakpoint-xl) mx-auto px-4 w-full">
        <component
          :is="loadersTypeMapper[loadingType] || loadersTypeMapper.default"
        />
      </div>
    </div>
  </Transition>
</template>

<style lang="css" scoped>
.preloader-wrapper {
  z-index: 19;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
  will-change: opacity;
  opacity: 1;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
